<template>
  <div class="m-container">
    <m_header></m_header>
    <m_menu></m_menu>
    <div class="m-body">
      <el-container class="m-title-box">
        <div class="m-title">
          <div class="m-title-t">用户申请报名管理</div>
          <span class="m-title-s">对用户申请报名进行查看，审批等操作</span>
        </div>
        <div class="m-tips">
          <i class="el-icon-warning"></i>使用提示
        </div>
      </el-container>
      <div class="m-table">
        <el-container class="m-table-head" v-loading="optLoading">
          <div class="m-enroll-opt" style="min-height: 110px;">
            <div v-for="(item, index) in optList" :key="index" :index="index" class="m-enroll-opt-item">
              <div class="m-enroll-opt-item-left" @click="listData(item.id, applyType)">
                <div class="m-enroll-opt-tit" :class="optForm.id === item.id ? 'opt-selected' : ''">
                  {{ item.title }}
                </div>
                <div class="m-enroll-opt-img">
                  <img :src="ossURL + item.imgPath" alt="" width="100%" height="100%">
                  <div class="m-enroll-opt-img-click">
                    <div class="opt-img-click-text">
                      点击查询列表
                    </div>
                  </div>
                </div>
              </div>
              <div class="m-enroll-opt-item-right">
                <div>
                  <div style="text-align: center;">
                    <el-tag v-if="item.status === '1'" size="medium" type="success">已开启</el-tag>
                    <el-tag v-else size="medium" type="info">已关闭</el-tag>
                  </div>
                  <div style="margin-top: 10px;">
                    <el-button type="primary" size="mini" @click="openOptForm(item)">编辑</el-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="m-table-btn">
            <!--<el-button @click="openPopup" type="primary" size="">新增合作商</el-button>-->
          </div>
        </el-container>
        <el-container class="m-table-opt">
          <div @click="listData(optForm.id,'0')" :class="applyType === '0' ? 'm-table-opt-this' : ''" class="m-table-opt-btn">未读</div>
          <div @click="listData(optForm.id,'1')" :class="applyType === '1' ? 'm-table-opt-this' : ''" class="m-table-opt-btn">已读</div>
        </el-container>
        <el-table :data="list" v-loading="isLoading" style="width: 100%;margin-bottom: 20px;" border>
          <el-table-column prop="userName" label="姓名" width="180"></el-table-column>
          <el-table-column prop="phone" label="电话" width="130" align="center"></el-table-column>
          <el-table-column prop="areaName" label="申请地区" width=""></el-table-column>
          <el-table-column prop="userExplain" label="用户说明" width=""></el-table-column>
          <el-table-column prop="remarks" label="备注" width=""></el-table-column>
          <el-table-column prop="createDate" label="提交时间" width="110" align="center"></el-table-column>
          <el-table-column label="操作" width="160" align="center" v-if="applyType === '0'">
            <template slot-scope="scope">
              <el-button type="primary" size="mini" @click="openForm(scope.row.id)" plain>标记已读</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <!-- 标记已读 -->
    <el-dialog title="标记已读" :visible.sync="openFormState" @close='closeFormDialog' width="500px" center :close-on-click-modal="false">
      <div class="m-open-coop-container" v-loading="formLoading">
        <el-form :model="form" ref="form" label-width="80px">
          <el-form-item label="备注: " prop="remarks">
            <el-input v-model="form.remarks" placeholder="输入备注(选填)"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-foote" style="text-align: center;">
          <el-button @click="openFormState = false">取 消</el-button>
          <el-button type="primary" @click="submitForm()">确 定</el-button>
        </div>
      </div>
    </el-dialog>
    <!-- 报名选项弹窗 -->
    <el-dialog title="报名信息" :visible.sync="openOptFormState" @close='closeOptFormDialog' width="700px" center :close-on-click-modal="false">
      <div class="m-open-coop-container" v-loading="optFormLoading">
        <el-form :model="optForm" :rules="optFormRules" ref="optForm" label-width="80px">
          <el-form-item label="标题: " prop="title">
            <el-input v-model="optForm.title" placeholder="输入标题"></el-input>
          </el-form-item>
          <el-form-item label="广告图片: " prop="imgPath">
            <div style="display: flex;">
              <div style="width: 30%;">
                <el-upload
                  drag
                  :action="uploadAction"
                  :headers="myHeaders"
                  accept=".jpg, .png"
                  :limit="1"
                  :file-list="fileLists"
                  :on-success="imgSuccess"
                  :on-remove="imgRemove">
                  <div style="font-size: 12px; line-height: 26px;display: flex; flex-wrap: wrap;align-items: center; height: 130px;">
                    <div>
                      <div style="width: 100%;"><i style="font-size: 28px" class="el-icon-upload2"></i></div>
                      <div style="width: 100%;text-align: center;">拖拽或<em style="color: #1c9dff">点击上传</em></div>
                    </div>
                  </div>
                </el-upload>
              </div>
              <div style="width: 70%">
                <div style="width: 253px; height: 128px;margin-left: 20px;border-radius: 8px;overflow: hidden;">
                  <img :src="ossURL + optForm.imgPath" alt="" width="100%" height="100%">
                </div>
              </div>
            </div>
          </el-form-item>
          <el-form-item label="头部提示: " prop="tipsTop">
            <div style="display: flex;">
              <div style="width: 50%">
                <el-input v-model="optForm.tipsTop" type="textarea" autosize placeholder="输入头部提示"></el-input>
              </div>
              <div style="width: 45%; margin-left: 10px; border: 1px solid #1c9dff;border-radius: 5px;padding: 5px;">
                <div style="line-height: 20px;border-bottom: 1px solid #1c9dff">演示：(以逗号","分割每段落)</div>
                <div v-for="(item, index) in optForm.tipsTop.split(',')" :key="index" style="line-height: 20px;">
                  {{ item }}
                </div>
              </div>
            </div>
          </el-form-item>
          <el-form-item label="底部提示: " prop="tipsBottom">
            <div style="display: flex;">
              <div style="width: 50%">
                <el-input v-model="optForm.tipsBottom" type="textarea" autosize placeholder="输入底部提示"></el-input>
              </div>
              <div style="width: 45%; margin-left: 10px; border: 1px solid #1c9dff;border-radius: 5px;padding: 5px;">
                <div style="line-height: 20px;border-bottom: 1px solid #1c9dff">演示：(以逗号","分割每段落)</div>
                <div v-for="(item, index) in optForm.tipsBottom.split(',')" :key="index" style="line-height: 20px;">
                  {{ item }}
                </div>
              </div>
            </div>
          </el-form-item>
          <el-form-item label="备注: " prop="remarks">
            <el-input v-model="optForm.remarks" type="textarea" autosize placeholder="输入备注"></el-input>
          </el-form-item>
          <el-form-item label="显示状态: " prop="status">
            <el-switch v-model="optIsActive" active-text="开启" inactive-text="关闭"></el-switch>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-foote" style="text-align: center;">
          <el-button @click="openOptFormState = false">取 消</el-button>
          <el-button type="primary" @click="submitOptForm()">确 定</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'applyManage',
  data () {
    return {
      isLoading: true,
      optLoading: true,
      openFormState: false,
      openOptFormState: false,
      formLoading: false,
      optFormLoading: false,
      applyType: '0', // 已读类型，默认未读
      ossURL: this.$httpConf.ossURL,
      optList: [], // 报名选项列表
      list: [], // 用户提交报名列表
      optIsActive: false,
      optForm: { // 报名选项form
        id: '',
        title: '',
        status: '',
        tipsTop: '',
        tipsBottom: '',
        imgPath: '',
        remarks: ''
      },
      uploadAction: '',
      myHeaders: { Authorization: JSON.parse(window.sessionStorage.user).Authorization },
      fileLists: [],
      imgDialogVisible: false,
      form: { // 提交已读form
        id: '',
        remarks: ''
      },
      optFormRules: {
        title: [
          { required: true, message: '请输入标题', trigger: 'blur' }
        ]
      }
    }
  },
  created () {
    // 赋值图片上传路径
    this.uploadAction = this.$httpConf.baseURL + '/enroll/uploadImage'
  },
  methods: {
    // 删除图片
    imgRemove () {
      this.optForm.imgPath = ''
      this.fileLists = []
    },
    // 图片上传成功
    imgSuccess (response, file, fileList) {
      if (file.response.status === 200) {
        this.optForm.imgPath = file.response.data
        this.fileLists = [{url: this.$httpConf.ossURL + file.response.data}]
        this.$message.success('上传成功')
      }
    },
    closeFormDialog () {
      this.form = {
        id: '',
        remarks: ''
      }
    },
    closeOptFormDialog () {
      this.optForm = {
        id: this.optForm.id,
        title: '',
        status: '',
        tipsTop: '',
        tipsBottom: '',
        imgPath: '',
        remarks: ''
      }
    },
    openOptForm (item) {
      this.optForm = {
        id: item.id,
        title: item.title,
        status: item.status,
        tipsTop: item.tipsTop,
        tipsBottom: item.tipsBottom,
        imgPath: item.imgPath,
        remarks: item.remarks
      }
      this.optIsActive = item.status === '1'
      this.openOptFormState = true
    },
    openForm (id) {
      this.openFormState = true
      this.form.id = id
    },
    submitOptForm () {
      let _this = this
      this.optForm.status = _this.optIsActive ? '1' : '0'
      this.$refs['optForm'].validate((valid) => {
        if (valid) {
          _this.optFormLoading = true
          this.$axios.post('/enroll/updateEnroll', _this.optForm)
            .then((res) => {
              if (res.status === 200) {
                _this.$message.success(res.msg)
                _this.openOptFormState = false
                _this.optData()
              } else {
                _this.$message.error(res.msg)
              }
              _this.optFormLoading = false
            })
        } else {
          return false
        }
      })
    },
    submitForm () {
      let _this = this
      _this.formLoading = true
      this.$axios.post('/enroll/isCheckApply', _this.form)
        .then((res) => {
          if (res.status === 200) {
            _this.$message.success(res.msg)
            _this.openFormState = false
            _this.formLoading = false
            _this.listData(_this.optForm.id, _this.applyType)
          } else {
            _this.$message.error(res.msg)
          }
        })
    },
    // 选项列表
    optData () {
      let _this = this
      _this.optLoading = true
      _this.optList = []
      this.$axios.post('/enroll/list')
        .then((res) => {
          _this.optList = res.data
          _this.optForm.id = res.data[0].id
          _this.listData(res.data[0].id, _this.applyType)
          _this.optLoading = false
        })
    },
    // 列表
    listData (parentId, checkState) {
      let _this = this
      _this.optForm.id = parentId
      _this.applyType = checkState
      _this.isLoading = true
      _this.list = []
      this.$axios.post('/enroll/applyList', {parentId: parentId, checkState: checkState})
        .then((res) => {
          _this.list = res.data
          _this.isLoading = false
        })
    }
  },
  mounted () {
    this.optData()
  }
}
</script>

<style>
.m-enroll-opt {
  display: flex;
}

.m-enroll-opt-item {
  margin-right: 20px;
  border: 1px solid #f2f2f2;
  color: #666666;
  display: flex;
}

.m-enroll-opt-item-left {
  border-right: 1px solid #f2f2f2;
  cursor: pointer;
}

.m-enroll-opt-item-right {
  width: 80px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
}

.m-enroll-opt-tit {
  font-size: 14px;
  font-weight: bold;
  text-align: center;
  border-bottom: 1px solid #f2f2f2;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.m-enroll-opt-img {
  width: 195px;
  height: 99px;
  position: relative;
}

.m-enroll-opt-img-click {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0,0,0,0.5);
  display: none;
}

.opt-img-click-text {
  width: 100%;
  height: 100%;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
}

.m-enroll-opt-item-left:hover .m-enroll-opt-tit{
  background-color: #1c9dff;
  color: #ffffff;
}

.m-enroll-opt-item-left:hover .m-enroll-opt-img-click{
  display: block;
}

.opt-selected {
  background-color: #1c9dff;
  color: #ffffff;
}

.el-upload-dragger {
  width: 170px;
  height: 130px;
  display: flex;
  align-items: center;
  justify-content: center;
}

</style>



// WEBPACK FOOTER //
// src/components/user/ApplyManage.vue